import { z } from 'zod';
import { PlatformEnvironment } from '@mews/enums';

export const configurationSchema = z.object({
    elementId: z.string(),
    configuration: z.object({
        assistantServiceUrl: z.string(),
        guestExperienceRestUrl: z.string(),
        guestProfileApiUrl: z.string(),
        guestAiServiceUrl: z.string(),
        environment: z.nativeEnum(PlatformEnvironment),
        platformPrimaryUrl: z.string(),
        platformApiUrl: z.string(),
        platformWebSocketUrl: z.string(),
        platformUrls: z.array(z.string()),
        assetBaseUrl: z.string(),
        assetUrl: z.string(),
        imageBaseUrl: z.string(),
        currentServerUrl: z.string(),
        posMicrosServiceUrl: z.string(),
        accountingExportServiceUrl: z.string(),
        routerBaseUrl: z.string(),
        serverBasePath: z.string(),
        platformVersion: z.string(),
        productName: z.string(),
        applicationInsightsInstrumentationKey: z.string().nullable(),
        sentryDsn: z.string().nullable(),
        sentryConfigurations: z.array(
            z.object({
                team: z.string(),
                scope: z.string().nullable(),
                dsn: z.string(),
            })
        ),
        surveySparrowAccount: z.string().nullable(),
        surveySparrowWidgetToken: z.string().nullable(),
        npsSurveySparrowWidgetToken: z.string().nullable(),
        cesSurveySparrowWidgetToken: z.string().nullable(),
        newRelic: z
            .object({
                eventEndpoint: z.string().nullable(),
                logEndpoint: z.string().nullable(),
                insertKey: z.string().nullable(),
            })
            .nullish(),
        userVoiceApiToken: z.string().nullable(),
        gtmContainerId: z.string().nullable(),
        statuspageScriptUrl: z.string().nullable(),
        pciProxyScriptUrl: z.string(),
        pciProxySecureFieldsScriptUrl: z.string(),
        launchDarklyToken: z.string().nullable(),
        launchDarklyOverrides: z
            .array(
                z.object({
                    key: z.string(),
                    value: z.boolean().or(z.string()).or(z.number()),
                })
            )
            .nullable(),
        cookieFirstToken: z.string().nullable(),
        gainsightToken: z.string(),
        fullViewToken: z.string(),
        cloudflareCaptchaSiteKey: z.string(),
    }),
    state: z.object({
        session: z.object({}),
    }),
    localization: z.object({
        languageCode: z.string(),
        cultureCode: z.string(),
    }),
    server: z.object({
        identifier: z.string(),
        instanceName: z.string(),
        buildDate: z.string(),
    }),
});

export type Configuration = z.infer<typeof configurationSchema>;
